import axios from 'axios'
// import { Message } from 'element-ui'
import store from '@/store'
// import router from "../router";
// import { getToken } from '@/utils/auth'
// create an axios instance
const service = axios.create({
  baseURL: `${window.config.api}`,
  // baseURL: process.env.NODE_ENV === 'development' ? `${require('../../public/setting').setting.api}/webapi` : `${window.setting.api}/webapi`,
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000, // request timeout
})
service.defaults.showLoader = true
// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent
    config.headers['Access-Control-Allow-Origin'] = '*'
    if (store.getters.token && !config.headers['Authorization']) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      // config.headers['X-Token'] = getToken()
      config.headers['Authorization'] = `Bearer ${store.getters.token}`
    }
    // config.headers['Accept-Encoding'] = 'gzip, deflate, br';
    // config.headers['Content-Encoding'] = 'gzip';
    if (config.showLoader && store.getters.singleRequestLoader) {
      store.dispatch('loader/pending')
    }
    return config
  },
  (error) => {
    // do something with request error
    if (error.config.showLoader && store.getters.singleRequestLoader) {
      store.dispatch('loader/done')
    }
    console.log('request error')
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    // const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    // if (res.code !== 20000) {
    //   Message({
    //     message: res.message || 'Error',
    //     type: 'error',
    //     duration: 5 * 1000
    //   })
    //
    //   // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
    //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
    //     // to re-login
    //     MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
    //       confirmButtonText: 'Re-Login',
    //       cancelButtonText: 'Cancel',
    //       type: 'warning'
    //     }).then(() => {
    //       store.dispatch('user/resetToken').then(() => {
    //         location.reload()
    //       })
    //     })
    //   }
    //   return Promise.reject(new Error(res.message || 'Error'))
    // } else {
    //   return res
    // }
    if (response.config.showLoader && store.getters.singleRequestLoader) {
      store.dispatch('loader/done')
    }
    return response.data
  },
  (error) => {
    if (!error.response || (error.response.config.showLoader && store.getters.singleRequestLoader)) {
      store.dispatch('loader/done')
    }
    console.log('response error')
    console.log('err:' + error) // for debug
    console.log('error.data')
    console.log(error.data)
    console.log('error.response')
    console.log(error.response)
    // return Promise.resolve({
    //   'Status': '9999',
    //   'Message': '系統忙碌中，請稍後再試'
    // });
    return Promise.reject(error)
  }
)

export default service
